import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useRemoveInternalAccountUser } from '../../data/useInternalAdmin';

interface RemoveAccountUserDialogProps {
  open: boolean;
  onClose: () => void;
  accountId: string | undefined;
  userId: string;
  displayName: string;
}

const RemoveAccountUserDialog: React.FC<RemoveAccountUserDialogProps> = ({
  open,
  onClose,
  accountId,
  userId,
  displayName,
}) => {
  const [error, setError] = React.useState<string | null>(null);
  const removeUser = useRemoveInternalAccountUser(accountId);

  const handleConfirm = () => {
    setError(null);
    removeUser.mutate(userId, {
      onSuccess: () => {
        onClose();
      },
      onError: (err: any) => {
        const detail = err?.response?.data?.detail || 'Failed to remove user';
        setError(detail);
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Remove User</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <DialogContentText>
          Remove <strong>{displayName}</strong> from this account? They will
          lose access immediately.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={removeUser.isPending}
        >
          {removeUser.isPending ? 'Removing...' : 'Remove'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveAccountUserDialog;
